import { FC, useState } from 'react';
import { Modal, Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
  RcFile,
  UploadChangeParam,
  UploadFile,
} from 'antd/lib/upload/interface';
import Paragrapgh from '../Paragrapgh';
import { getBase64 } from '../../../lib/common.helpers';

interface IOwnProps {
  fileList?: UploadFile<any>[];
  label: string;
  handleChangeImages: (files: UploadFile<any>[]) => void;
  disabled?: boolean;
}

const PicturesWall: FC<IOwnProps> = ({
  fileList,
  label,
  handleChangeImages,
  disabled,
}) => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');

  const handleCancel = () => setPreviewVisible(false);

  const handlePreview = async (file: any) => {
    /* eslint no-param-reassign: ["error", { "props": false }] */
    if (!file.url && !file.thumbUrl) {
      file.thumbUrl = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.thumbUrl);
    setPreviewVisible(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexof('/') + 1),
    );
  };

  const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
    const { file } = info;
    if (file.status === 'removed') {
      handleChangeImages([
        ...new Set(fileList?.filter(image => image.uid !== file.uid)),
      ]);
    }
  };

  const handleBeforeUpload = (file: RcFile, imgList: RcFile[]) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = e => {
      const { uid, name, type, size } = file;

      const image = {
        uid,
        name,
        type,
        size,
        thumbUrl: e.target?.result,
      };

      handleChangeImages([...new Set(fileList), image as UploadFile]);
    };
    return false;
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload Photo</div>
    </div>
  );

  return (
    <>
      <Paragrapgh
        className='mb-4 d-block'
        size={2}
        color='black'
        align='default'
        fontWeight={400}
      >
        {label}
      </Paragrapgh>
      <Upload
        className='pictures-wall mb-24'
        listType='picture-card'
        fileList={fileList}
        accept='image/x-png,image/gif,image/jpeg'
        onPreview={handlePreview}
        onChange={handleChange}
        beforeUpload={handleBeforeUpload}
        disabled={disabled}
      >
        {uploadButton}
      </Upload>
      <Modal
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img src={previewImage} alt='Assessment' style={{ width: '100%' }} />
      </Modal>
    </>
  );
};

export default PicturesWall;
